import { useState } from "react";
import type { ActivityReservationPageProps } from "@b2bportal/core-activities";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreActivitiesComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripsAppPage } from "@tenant/ui";
import clsx from "clsx";
import styles from "./ActivityReservationPage.module.scss";
import { TripDetailContent } from "./components";
import { useActivityReservationPage } from "./useActivityReservationPage";
import { ActivityReservationCancellation } from "@/modules/activities-postbooking/components";
import { PageLoadingScreen } from "@/overrides/core-ui/PageLoadingScreen/PageLoadingScreen";

const COMPONENT_KEY = CoreActivitiesComponent.ActivityReservationPage;

export const ActivityReservationPage = ({
  context,
  className,
  children,
}: ActivityReservationPageProps) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();
  const [showCancellation, setShowCancellation] = useState(false);

  const { singleItinerary, isLoading, isActiveBooking } =
    useActivityReservationPage(context);

  const hasErrorOrNoData =
    context.isError || context.activityReservation == null;

  return (
    <TripsAppPage
      className={clsx(block, className)}
      contentClassName={cn("content")}
    >
      {isLoading ? (
        <PageLoadingScreen isLoading text={t("fetchingTrips")} />
      ) : hasErrorOrNoData ? null : showCancellation &&
        singleItinerary.reservation != null ? (
        <ActivityReservationCancellation
          reservation={singleItinerary.reservation}
          onBack={() => setShowCancellation(false)}
        />
      ) : (
        <TripDetailContent
          singleItinerary={singleItinerary}
          isActiveBooking={isActiveBooking}
          onQueryCancellation={() => setShowCancellation(true)}
        >
          {children}
        </TripDetailContent>
      )}
    </TripsAppPage>
  );
};
